import React, { useEffect, useState } from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaLandmark, FaSun, FaHiking, FaBeer, FaGift } from "react-icons/fa";

const Timeline = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const timeline = document.querySelector(".vertical-timeline");
      if (timeline && timeline.getBoundingClientRect().top < window.innerHeight * 0.75) {
        setAnimate(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="timeline-section">
      <h2 className="section-title">Unsere Geschichte</h2>
      <VerticalTimeline className={animate ? "visible" : ""}>
        <VerticalTimelineElement
          date="1984"
          iconStyle={{ background: "#1976d2", color: "#fff" }}
          icon={<FaLandmark />}
        >
          <h3 className="vertical-timeline-element-title">Gründung des Vereins</h3>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          date="2006"
          iconStyle={{ background: "#1976d2", color: "#fff" }}
          icon={<FaSun />}
        >
          <h3 className="vertical-timeline-element-title">Großes Sommerfest</h3>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          date="2022"
          iconStyle={{ background: "#1976d2", color: "#fff" }}
          icon={<FaHiking />}
        >
          <h3 className="vertical-timeline-element-title">Erste Himmelfahrtwanderung</h3>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          date="2022"
          iconStyle={{ background: "#1976d2", color: "#fff" }}
          icon={<FaBeer />}
        >
          <h3 className="vertical-timeline-element-title">Erstes Oktoberfest</h3>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          date="2024"
          iconStyle={{ background: "#1976d2", color: "#fff" }}
          icon={<FaGift />}
        >
          <h3 className="vertical-timeline-element-title">40-jähriges Jubiläum</h3>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  );
};

export default Timeline;
